module.exports = __webpack_public_path__ + "img/id.5012ed3.svg";